import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ModalItem({
  buttonLabel,
  modalTitle,
  modalBody,
  className,
  iconClass,
}) {
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }

  return (
    <>
      <Button
        className={'btn '.concat(className)}
        style={{ border: 'none' }}
        onClick={() => handleShow(true)}
      >
        <i className={`${iconClass} me-1`}></i>
        {buttonLabel}
      </Button>
      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalBody}</Modal.Body>
      </Modal>
    </>
  );
}

export default ModalItem;
